/**
 * Empty stub for Node.js 'fs' module
 * Used to allow ical-generator to work in browser environment
 * The actual writeFile function is never called in browser context
 */

// Export empty stubs for fs functions that ical-generator imports
export const writeFile = () => {
  console.warn("fs.writeFile is not available in browser environment");
  return Promise.reject(new Error("fs.writeFile is not available in browser"));
};

export const readFile = () => {
  console.warn("fs.readFile is not available in browser environment");
  return Promise.reject(new Error("fs.readFile is not available in browser"));
};

export const writeFileSync = () => {
  console.warn("fs.writeFileSync is not available in browser environment");
  throw new Error("fs.writeFileSync is not available in browser");
};

export const readFileSync = () => {
  console.warn("fs.readFileSync is not available in browser environment");
  throw new Error("fs.readFileSync is not available in browser");
};

export const promises = {
  writeFile,
  readFile,
};

export default {
  writeFile,
  readFile,
  writeFileSync,
  readFileSync,
  promises,
};
